import { createStore } from 'vuex'

import business_units from '@/store/BusinessUnit/index.js'
import locations from '@/store/Location/index.js'
import navigation from '@/store/Navigation/index.js'
import posts from '@/store/Post/index.js'
import post_categories from '@/store/PostCategory/index.js'
import products from '@/store/Product/index.js'

export default createStore({
  modules: {
    business_units,
    locations,
    navigation,
    posts,
    post_categories,
    products,
  },
  actions: {
    clearData({ dispatch }) {
      dispatch('emptyLocations')
      dispatch('emptyPosts')
      dispatch('emptyPostCategories')
      dispatch('emptyProducts')
    },
  },
})
